

// 定义公告得固定数据
export const topNavarr = [   // 导航二
    
    {
        url: "/agency",
        link: "",
        name: "nav.vip",
        isGame: false,
        logoImg: require("./img/nav/VIP-Default.svg"),
        logoImg_: require("./img/nav/VIP-Active.svg"),
    },
    {
        url: "/discounts/all",
        link: "",
        name: "nav.discounts",
        isGame: false,
        logoImg: require("./img/nav/Promotions-Default.svg"),
        logoImg_: require("./img/nav/Promotions-Active.svg"),
    },
    {
        url: "/team/mypromoition",
        link: "",
        name: "nav.Commission",
        isGame: false,
        logoImg: require("./img/nav/Commission-Default.svg"),
        logoImg_: require("./img/nav/Commission-Active.svg"),
    },
    {
        url: "/discounts/all",
        link: "",
        name: "nav.Blog",
        isGame: false,
        logoImg: require("./img/nav/Blog-Default.svg"),
        logoImg_: require("./img/nav/Blog-Active.svg"),
    },
    // { url: "/agency", link: "", name: "nav.Affiliate", isGame:false,
    //     logoImg: require("./img/nav/Home-Default.svg"),
    //     logoImg_: require("./img/nav/Home-Active.svg"),
	// },
    // {
    //     url: "/team",
    //     link: "",
    //     name: "nav.agency",
    //     isGame:false,
    //     logoImg: require("./img/nav/Home-Default.svg"),
    //     logoImg_: require("./img/nav/Home-Active.svg"),
    // },
    // {
    //     url: "/team",
    //     link: "",
    //     name: "nav.Help",
    //     isGame:false,
    //     logoImg: require("./img/nav/Home-Default.svg"),
    //     logoImg_: require("./img/nav/Home-Active.svg"),
    // },
    // {
    //     url: "/team",
    //     link: "",
    //     name: "nav.online",
    //     isGame:false,
    //     logoImg: require("./img/nav/Home-Default.svg"),
    //     logoImg_: require("./img/nav/Home-Active.svg"),
    // },
    // {
    //     url: "",
    //     link: "",
    //     name: "nav.APPDownload",
    //     isGame: 'APPDownload',
    //     logoImg: require("./img/nav/r_app.png"),
    // },
]

export const topNavList = [ // 导航一
    {
        url: "/home",
        link: "",
        name: "nav.home",
        isGame: false,
        logoImg: require("./img/nav/Home-Default.svg"),
        logoImg_: require("./img/nav/Home-Active.svg"),
    },
    {
        url: "/sports",
        link: "",
        name: "nav.sport",
        isGame: false,
        logoImg: require("./img/nav/Sport-Default.svg"),
        logoImg_: require("./img/nav/Sport-Active.svg"),
    },
    {
        url: "/games",
        link: "",
        name: "nav.live",
        isGame: false,
        logoImg: require("./img/nav/Live-Casino-Default.svg"),
        logoImg_: require("./img/nav/Live-Casino-Active.svg"),
    },
    {
        url: "/games",
        link: "",
        name: "nav.slot",
        isGame: false,
        logoImg: require("./img/nav/Slot-Default.svg"),
        logoImg_: require("./img/nav/Slot-Active.svg"),
    },
    {
        url: "/games",
        link: "",
        name: "nav.rummy",
        isGame: false,
        logoImg: require("./img/nav/Rummy-Default.svg"),
        logoImg_: require("./img/nav/Rummy-Active.svg"),
    },
    {
        url: "/games",
        link: "",
        name: "nav.ColorLight",
        isGame: false,
        logoImg: require("./img/nav/Lottery-Default.svg"),
        logoImg_: require("./img/nav/Lottery-Active.svg"),
    },
    // {
    //     url: "/games",
    //     link: "",
    //     name: "nav.games",
    //     isGame: false,
    //     logoImg: require("./img/nav/Live-Casino-Default.svg"),
    //     logoImg_: require("./img/nav/Live-Casino-Active.svg"),
    // },
    {
        url: "/fish",
        link: "",
        name: "nav.Fishing",
        isGame: false,
        logoImg: require("./img/nav/Live-Casino-Default.svg"),
        logoImg_: require("./img/nav/Live-Casino-Active.svg"),
    },
    // {
    //     url: "/team",
    //     link: "",
    //     name: "nav.team",
    //     isGame: false,
    //     logoImg: require("./img/nav/Live-Casino-Default.svg"),
    //     logoImg_: require("./img/nav/Live-Casino-Active.svg"),
    // },
    // {
    //     url: "/live",
    //     link: "",
    //     name: "nav.live",
    //     isGame: false,
    //     logoImg: require("./img/nav/r_live.png"),
    // },
    // {
    //     url: "/slots",
    //     link: "",
    //     name: "nav.slot",
    //     isGame: false,
    //     logoImg: require("./img/nav/r_slots.png"),
    // },
    // {
    //     url: "/ColorLight",
    //     link: "",
    //     name: "nav.ColorLight",
    //     isGame:false,
    //     logoImg: require("./img/nav/r_lottery.png"),
    // },
]

export const footerNav = [ // 底部
    {
        url: "/team",
        link: "",
        name: "nav.team",
        isGame: false,
    },
    {
        url: "/discounts/all",
        link: "",
        name: "nav.discounts",
        isGame: false,
    },
]

export const fixedTextList =[
    { 
        index:0,
        icon:require('./img/h_card/bottom_bank.png'),
    },
    { 
        index:1,
        icon:require('./img/h_card/bottom_phonepe.png'),
    }, 
    { 
        index:2,
        icon:require('./img/h_card/bottom_paytm.png'),
    },
    { 
        index:3,
        icon:require('./img/h_card/bottom_BHIM.png'),
    },
    { 
        index:4,
        icon:require('./img/h_card/bottom_skrill.png'),
    },
    { 
        index:5,
        icon:require('./img/h_card/bottom_neteller.png'),
    },
    { 
        index:6,
        icon:require('./img/h_card/amazon_pay.png'),
    },
    { 
        index:7,
        icon:require('./img/h_card/google_pay.png'),
    },
]



// WEBPACK FOOTER //
// ./src/pages/build902/components/common/comdata.js